import { render, staticRenderFns } from "./create-faq.vue?vue&type=template&id=04f3536a&scoped=true&"
import script from "./create-faq.vue?vue&type=script&lang=js&"
export * from "./create-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3536a",
  null
  
)

export default component.exports